import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ApiClient } from 'spry-react/utils/apiClient';

export function registrationRoutes(loaderApiClient: ApiClient): RouteObject {
  return {
    path: "register/new/:code",
    lazy: async () => {
      const { loader, RegistrationPage } = await import('./registrationPage');
      return {
        element: <RegistrationPage />,
        loader: (args) => loader(loaderApiClient, args.params.code),
      };
    },
  };
}

